import React, { useLayoutEffect, useState } from 'react';
import { CiHeart } from 'react-icons/ci';

import { ItemGroupProps } from 'types/ItemGroupProps';
import noImage from 'assets/banner-unico.png';
import * as S from './styles';

interface ProductsCarouselProps {
  data: ItemGroupProps;
  phoneWidth: number;
}

interface Product {
  imgUrl: string;
  price: number;
  title: string;
}

export default function ProductsCarousel({ data }: ProductsCarouselProps) {
  const [products, setProducts] = useState<Product[]>([]);

  useLayoutEffect(() => {
    if (data.products && data.products.length > 0) {
      const newProducts: Product[] = [];
      data.products.forEach(item => {
        newProducts.push({
          imgUrl: item?.items[0]?.images[0]?.imageUrl || '',
          price: item?.items[0]?.sellers[0]?.commertialOffer.Price || 10,
          title: item.productName || 'No name',
        });
      });

      if (newProducts.length > 0) {
        setProducts(newProducts);
      }
    }
  }, []);

  return (
    <S.container>
      {products.length === 0 ? (
        <S.noProducts>
          <p>No itens</p>
        </S.noProducts>
      ) : (
        <S.productsContainer>
          {products.map(item => (
            <S.product>
              <CiHeart />
              <img src={item.imgUrl || noImage} />
              <p>
                {item?.price?.toLocaleString('en-US', {
                  style: 'currency',
                  currency: 'USD',
                })}
              </p>
              <h2>{item?.title || 'No title'}</h2>
              <S.btnBuy>
                <p>Agregar al carrito</p>
              </S.btnBuy>
            </S.product>
          ))}
        </S.productsContainer>
      )}
    </S.container>
  );
}
